import { Card, Box, Grid, CardMedia, CardContent } from "@mui/material";
import theme from "../theme";
import transactions from "./transactions.json";

export const MainCardWithTiltedCards: React.FC = () => {
  return (
    <Box sx={{ height: 700, overflow: "hidden", position: "relative" }}>
      {/* Main Card Content Here */}

      {/* Container for the tilted cards */}
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "absolute",
          left: "50%",
          top: "-20%",
          transform: "translateX(-20%)",
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            transform: "rotate(-21deg)",
          }}
        >
          {transactions.map((transaction, index) => (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <Box
                sx={{
                  //minWidth: "180px",

                  //maxWidth: { xs: "180px", sm: "210px", lg: "230px" },
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                <Card
                  sx={{
                    position: "relative", // Set the card's position to relative
                    minWidth: { xs: "185px", sm: "186px", lg: "186px" },
                    minHeight: { xs: "185px", sm: "210px", lg: "210px" },
                    background: "#161b22",
                    "&:hover": {
                      transform: "scale(1.03)",
                      transition: "0.05s ease-in-out",
                      cursor: "pointer",
                    },
                    //maxheight: 150,
                    marginBottom: 0,

                    borderRadius: "3.6px",
                    justifyContent: "center",
                    alignContent: "center",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.1)",
                    border: "1px solid #30363d",
                  }}
                  elevation={3}
                >
                  <Box
                    sx={{
                      marginBottom: 0,
                      height: "45px",
                      //minWidth: "180px",
                      marginTop: "0px",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: { xs: "center", sm: "center" },
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{
                        filter:
                          theme.palette.mode === "light"
                            ? null
                            : "invert(100%) grayscale(100%) brightness(200%)",
                        maxWidth: { xs: "90px", sm: "100px" },
                        maxHeight: "42px",
                        marginBottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        objectFit: "contain",
                        marginTop: "17%",
                        borderRadius: "5px",
                      }}
                      image={transaction["image"]}
                      alt="Company Logo"
                    />
                  </Box>

                  <CardContent sx={{ justifyContent: "center" }}>
                    <Box
                      sx={{
                        marginBottom: 0.1,
                        mt: 1.2,
                        alignContent: "center",
                        justifyContent: "center",
                        display: "flex",
                        fontWeight: "500",
                        fontSize: "10px",
                        //color: "#03060b",
                      }}
                    >
                      {transaction["Company Name"]}
                    </Box>
                    <Box
                      sx={{
                        marginBottom: 1.2,
                        fontWeight: "700",
                        fontSize: {
                          xs: "15px",
                          sm: "15px",
                          md: "16px",
                          lg: "17px",
                        },
                        //color: "#03060b",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {transaction["currencyType"]} {transaction["amountSize"]}
                      {transaction["amountType"]}
                    </Box>
                    <Box
                      sx={{
                        marginBottom: 1.5,
                        fontWeight: "500",
                        //maxWidth: "100px",
                        ml: 2,
                        mr: 2,

                        fontSize: { xs: "9px", sm: "12px" },
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        //color: "#03060b",
                        textAlign: "center",
                      }}
                    >
                      {transaction["Type Of Transaction"]}
                    </Box>
                    <Box
                      sx={{
                        fontWeight: { xs: "500", sm: "700" },
                        fontSize: { xs: "10px", sm: "12px" },
                        //color: "#03060b",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        position: "absolute",
                        ml: { xs: 1, sm: 2 },
                        mr: { xs: 1, sm: 2 },
                        bottom: "6%", // Position the Box 6 pixels from the bottom
                        left: 0,
                        right: 0,
                      }}
                    >
                      {transaction["arrangerRole"]}
                    </Box>
                    {/*
          <Box
						sx={{
							marginBottom: 0,
							fontWeight: "500",
							fontSize: "10px",
							color: "#03060b",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						{transaction["Year"]}
					</Box>
          */}
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
